import { Navigate, useLocation } from 'react-router-dom'
import { useClassCode } from '../context/ClassCodeContext'

export function RequireUnlocked({ children }: { children: React.ReactNode }) {
  const { isUnlocked } = useClassCode()
  const location = useLocation()

  if (!isUnlocked) {
    return <Navigate to="/unlock" state={{ from: location }} replace />
  }

  return <>{children}</>
}
